import React, { useState } from 'react';
import { Translate, TranslateScope } from '@pegasus/translation';
import { useConfig, ImageSize } from '@browsing/config';
import { ResponsiveCarousel } from '@lux/carousel';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { useTrackViewItemList, trackSelectItem } from '@browsing/tracking';
import { topPicksTracker } from './tracking';
import { CarouselArticleCard } from './carousel-article-card';
import * as S from './styles';
export var Carousel = function (_a) {
    var carouselItems = _a.carouselItems, isInView = _a.isInView, isOmnibusRrpExperiment = _a.isOmnibusRrpExperiment, omnibusPolandOrItaly = _a.omnibusPolandOrItaly;
    var config = useConfig();
    var slicedCarouselItems = useState(carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.slice(0, 8))[0];
    useTrackViewItemList({
        items: slicedCarouselItems,
        payload: {
            element: 'tp4u',
            item_list_name: 'tp4u',
        },
        itemMapper: function () { return ({
            item_list_name: 'tp4u',
            recommended: 'reco',
        }); },
        triggerCondition: slicedCarouselItems.length !== 0 && isInView,
    });
    var trackProductClick = function (product, idx) { return function (_) {
        topPicksTracker.track('select_item_tp4u', {
            component: 'TP4U_showstopper',
            productCampaign: product.campaignIdentifier,
            productSku: product.sku,
            positionNumber: idx + 1,
            isTP4U: 1,
        });
        if (config.isEnabled('ga4')) {
            trackSelectItem({
                element: 'tp4u',
                itemListName: 'tp4u',
                item: product,
            }, {
                customMapper: function () { return ({ index: idx }); },
            });
        }
    }; };
    var trackLastSeeAllClick = function () {
        topPicksTracker.track('seeAll_last_TP4U', {
            component: 'TP4U_showstopper',
            isTP4U: 1,
        });
    };
    return (React.createElement(TranslateScope, { path: "myLounge" },
        React.createElement(ResponsiveCarousel, { visibleItems: 2, visibleItemsXs: 3, visibleItemsSm: 4, visibleItemsLg: 6, singleStep: true, carouselLabel: "Carousel", previousSlideLabel: "previous", nextSlideLabel: "next", key: "top-picks-carousel-".concat(carouselItems.length) },
            slicedCarouselItems.map(function (article, index) {
                return (React.createElement(CarouselArticleCard, { article: article, key: "top-picks-".concat(index), handleOnClick: trackProductClick(article, index), src: config.getImage(article.images[0], ImageSize.Small), isOmnibusRrpExperiment: isOmnibusRrpExperiment, omnibusPolandOrItaly: omnibusPolandOrItaly }));
            }),
            React.createElement(S.LastSeeAll, { as: "a", onClick: trackLastSeeAllClick, href: "/campaigns/top-picks/articles" },
                React.createElement(Button, { buttonType: ButtonType.tertiary, color: ButtonColor.dark },
                    React.createElement(Translate, { message: "TP4U.cta" }))))));
};
